import React, { useState, useEffect } from "react";
import SecurityIcon from "../../assets/png/security.png";
import "./Drawer.css";

const CustomizeTime = ({
  setFilterStartDate,
  setFilterEndDate,
  filterStartDate: initialStartDate,
  filterEndDate: initialEndDate,
}) => {
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [error, setError] = useState("");

  useEffect(() => {
    setStartDate(initialStartDate || "");
    setEndDate(initialEndDate || "");
  }, [initialStartDate, initialEndDate]);

  const handleContinue = () => {
    if (!startDate) {
      setError("Please select Start date");
      return;
    }

    if (!endDate) {
      setError("Please select End date");
      return;
    }

    setError("");
    setFilterStartDate(startDate);
    setFilterEndDate(endDate);
    document.getElementById("closeCustoizeFilterDrawer").click();
  };

  return (
    <>
      <span
        id="closeCustoizeFilterDrawer"
        data-bs-dismiss="offcanvas"
        aria-label="Close"
      ></span>
      <div className="customize-time-drawer-wrapper">
        <div className="customize-time-wrap">
          <p> Select your date range within 12 months.</p>

          <div className="time-range-wrapper">
            <div className="start-time">
              <label> Start Date</label>
              <input
                type="date"
                onChange={(e) => {
                  setStartDate(e.target.value);
                }}
                value={startDate}
              />
              {error === "Please select Start date" && (
                <p className="date-error-message">{error}</p>
              )}
            </div>
            <h4> To </h4>
            <div className="start-time">
              <label> End Date</label>
              <input
                type="date"
                onChange={(e) => {
                  setEndDate(e.target.value);
                }}
                value={endDate}
              />
              {error === "Please select End date" && (
                <p className="date-error-message">{error}</p>
              )}
            </div>
          </div>

          <div className="customize-range-footer">
            <div className="customize-security">
              <img src={SecurityIcon} alt="icon" />
              <p>
                You have the option to filter within a specific 12-month range.
                Kindly ensure that your selections remain within this designated
                timeframe
              </p>
            </div>

            <div className="customize-btn">
              <button onClick={handleContinue}> Continue </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default CustomizeTime;
